<template>
  <div class="app">
    <navbar></navbar>
    <div class="banner">
      <div class="banner-row">
        <div class="banner-column">
          <p class="banner-info">19/10/19</p>
          <p class="banner-info-small">19:00</p>
        </div>
        <img class="logo" alt="Body Machine Body festival" src="./assets/BMB_2019_ANIMATED.svg">
        <div class="banner-column">
          <p class="banner-info">CLUB HALL</p>
          <a class="banner-info-small" style="cursor: pointer" href="#location">PEETRI 6, TALLINN ESTONIA</a>
        </div>
      </div>

      <div class="banner-row-mobile">
        <div class="banner-column-mobile">
          <p class="banner-info">19/10/19</p>
          <p style="margin-bottom: 0; cursor: pointer"><a class="banner-info-small" href="#location">CLUB HALL</a></p>
          <p style="margin: 0; cursor: pointer"><a class="banner-info-small" href="#location">TALLINN, ESTONIA</a></p>
        </div>
      </div>

      <div class="button"><a class="button-text" href="#tickets"><p>TICKET INFO</p></a></div>
      <div></div>

    </div>
    <a id="artists"></a>
    <div class="component">
      <p class="component-heading">ARTISTS</p>
      <artists></artists>
    </div>

    <a id="tickets"></a>
    <div class="component">
      <p class="component-heading">TICKETS</p>
      <tickets></tickets>
    </div>

    <!--<a id="schedule"></a>
    <div class="component">
      <p class="component-heading">SCHEDULE</p>
      <schedule></schedule>
    </div>-->

    <a id="news"></a>
    <div class="component" style="background-color: #cdcdcd; margin-bottom: 0">
      <p class="component-heading">NEWS</p>
      <news></news>
    </div>

    <a id="location"></a>
    <div class="component">
      <p class="component-heading">LOCATION</p>
      <location></location>
    </div>

    <a id="contact"></a>
    <div class="component">
      <p class="component-heading">CONTACT</p>
      <contact></contact>
    </div>

    <p class="copyright">Body Machine Body festival © 2019</p>
  </div>
</template>

<script>
  import Artists from './components/Artists'
  import Navbar from './components/Navbar'
  import Location from './components/Location'
  import Contact from './components/Contact'
  import Tickets from './components/Tickets'
  import News from './components/News'
  import Schedule from './components/Schedule'

  export default {
    name: 'app',
    components: {
      Schedule,
      Artists,
      Navbar,
      Location,
      Contact,
      Tickets,
      News
    }
  }
</script>

<style>
  @font-face {
    font-family: 'Tw Cen MT';
    font-style: normal;
    font-weight: normal;
    src: local('Tw Cen MT'), url('assets/font/Tw Cen MT.woff') format('woff');
  }

 @font-face {
    font-family: 'Champagne-Limousines-Thick';
    font-style: normal;
    font-weight: normal;
    src: local('Champagne-Limousines-Thick'), url('assets/font/Champagne-Limousines-Thick.woff') format('woff');
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
  }

  .app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    background-color: #0d2f39;
  }

  .banner {
    height: 100vh;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex-direction: column;
  }

  @media (max-width: 425px) {
    .banner {
      justify-content: space-evenly;
    }
  }

  .banner-row {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  @media (max-width: 425px) {
    .banner-row {
      display: unset;
    }
  }

  .banner-row-mobile {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  @media (min-width: 426px) {
    .banner-row-mobile {
      display: none;
    }
  }

  .banner-column {
    margin: 0 60px;
    flex-direction: column;
    width: 100%;
  }

  @media (max-width: 425px) {
    .banner-column {
      display: none;
    }
  }

  .banner-info {
    font-family: 'Tw Cen MT';
    color: #cdcdcd;
    font-size: 32px;
  }

  @media (max-width: 425px) {
    .banner-info {
      margin: 0;
      font-size: 24px;
    }
  }

  .banner-info-small {
    font-family: 'Tw Cen MT';
    color: #cdcdcd;
    font-size: 26px;
  }

  .banner-info-small:hover {
    color: white;
  }

  @media (max-width: 425px) {
    .banner-info-small {
      font-size: 16px;
    }
  }

  .logo {
    width: 40%;
    min-width: 500px;
    margin-bottom: 20px;
  }

  @media (max-width: 576px) {
    .logo {
      margin-bottom: 0;
      min-width: 75vw;
    }
  }

  .button {
    border: 3px solid white;
    margin: 30px auto 0;
    cursor: pointer;
    width: 30%;
    align-content: center;
    border-radius: 3px;
    transition: transform .2s;
  }

  @media (max-width: 425px) {
    .button {
      width: 80%;
      margin-top: 0;
    }
  }

  .button:hover {
    box-shadow: 0 1px 20px rgba(21, 25, 34, 0.8);
    transform: scale(1.01, 1.01);
  }

  .button-text {
    color: white;
    font-size: 22px;
    font-family: 'Tw Cen MT';
    letter-spacing: 5px;
  }

  .button-text:hover {
    color: white;
  }

  @media (max-width: 425px) {
    .button-text {
      font-size: 18px;
    }
  }

  .component-heading {
    background-color: #031D24;
    font-size: 24px;
    padding: 50px 0;
    margin: 0;
    color: #cdcdcd;
    font-family: 'Tw Cen MT';
    letter-spacing: 8px;
  }

  @media (max-width: 425px) {
    .component-heading {
      font-size: 18px;
      padding: 30px 0;
    }
  }

  .component {
    background-color: #0d2f39;
  }

  .copyright {
    background-color: #cdcdcd;
    padding: 20px; font-size: 14px
  }
</style>
